import React from "react";
import { useSelector } from "react-redux";
import { selectInfoPage } from "slices/textSlice";
import InfoPage from "./InfoPage/InfoPage";
import ChannelPage from "./ChannelPage/ChannelPage";
import {
  APP_CODE_BRANCH,
  APP_CODE_ROOM,
  APP_CODE_TEXT_CHANNEL,
} from "constants/constants";
import SpacePage from "./SpacePage/SpacePage";

const TextBody = ({ currentAppId }) => {
  const infoPage = useSelector(selectInfoPage);

  if (infoPage || currentAppId === APP_CODE_BRANCH) return <InfoPage />;
  else if (currentAppId === APP_CODE_TEXT_CHANNEL) return <ChannelPage />;
  else if (currentAppId === APP_CODE_ROOM) return <SpacePage />;
  else return <ChannelPage />;
};

export default TextBody;
